export const ORDER_PERMISSIONS = {
    EDIT: 'ORDER_EDIT',
    DELETE: 'ORDER_DELETE',
    STATUS_CHANGE: 'ORDER_STATUS_CHANGE',
    WORKER_CHANGE: 'ORDER_WORKER_CHANGE',
    PAYMENT_CHANGE: 'ORDER_PAYMENT_CHANGE',
    PRINT: 'ORDER_PRINT',
    HISTORY_VIEW: 'ORDER_HISTORY_VIEW',
    INTEGRATION_RETRY: 'ORDER_INTEGRATION_RETRY',
    ACTIONS_CONFIGURED: 'ORDER_ACTIONS_CONFIGURED',
}

export const ORDER_ACTION_PERMISSIONS = [
    { key: ORDER_PERMISSIONS.EDIT, label: 'Редактирование заказа' },
    { key: ORDER_PERMISSIONS.DELETE, label: 'Удаление заказа' },
    { key: ORDER_PERMISSIONS.STATUS_CHANGE, label: 'Изменение статуса' },
    { key: ORDER_PERMISSIONS.WORKER_CHANGE, label: 'Назначение исполнителя' },
    { key: ORDER_PERMISSIONS.PAYMENT_CHANGE, label: 'Изменение способа оплаты' },
    { key: ORDER_PERMISSIONS.PRINT, label: 'Печать заказа' },
    { key: ORDER_PERMISSIONS.HISTORY_VIEW, label: 'Просмотр истории заказа' },
    { key: ORDER_PERMISSIONS.INTEGRATION_RETRY, label: 'Повторная отправка во внешнюю систему' },
]

const LEGACY_ALLOWED_PERMISSIONS = new Set([
    ORDER_PERMISSIONS.EDIT,
    ORDER_PERMISSIONS.DELETE,
    ORDER_PERMISSIONS.STATUS_CHANGE,
    ORDER_PERMISSIONS.WORKER_CHANGE,
    ORDER_PERMISSIONS.PAYMENT_CHANGE,
    ORDER_PERMISSIONS.PRINT,
    ORDER_PERMISSIONS.HISTORY_VIEW,
    ORDER_PERMISSIONS.INTEGRATION_RETRY,
])

export const hasOrderPermission = (user = {}, permission) => {
    if (!permission) return false
    const role = String(user?.role || '').toUpperCase()
    const userId = Number(user?.id || 0)
    const hasParentId = user?.id_parent !== undefined || user?.idParent !== undefined
    const parentId = Number(user?.id_parent ?? user?.idParent ?? 0)
    if (role === 'SA' || (userId > 0 && hasParentId && parentId === 0)) return true
    const access = Array.isArray(user?.accessPage) ? user.accessPage : []
    if (access.includes(permission)) return true
    const actionsConfigured = access.includes(ORDER_PERMISSIONS.ACTIONS_CONFIGURED)
    return !actionsConfigured && access.includes('ALLORDER') && LEGACY_ALLOWED_PERMISSIONS.has(permission)
}
